import React from "react";
import * as moment from "moment-timezone";
import { toCamelCase } from "../../../../hooks/toCameCase.tsx";
import { ReporteRow } from "../../../../models/ReporteChequeo";
import {
  calcularTiempoTrabajado,
  calcularTurno,
} from "../../../../interfaces/formik/IReporteRelojChecador.ts";
import ModalContainer from "../../../ModalContainer.tsx";
import ModalCheckDetails from "./ModalCheckDetails.tsx";
import useFetchCheckDetailsTwoIds from "../../../profile/hooks/useFetchCheckDetailsTwoIds.tsx";

const RowReporteChequeoCodigo = ({ record }: { record: ReporteRow }) => {
  const {
    checkDetails,
    openCheckDetails,
    setOpenCheckDetails,
    fetchCheckDetails,
    profileImage,
  } = useFetchCheckDetailsTwoIds();
  const calculatedShift = calcularTurno(
    record.checkIn?.assistanceCheck_checkTime ?? ""
  );
  const registeredShift = record.checkIn?.candidate_shift_name;
  const isNocturno = String(registeredShift || "")
    .trim()
    .toLowerCase() === "nocturno";

  const handleClick = async () => {
    const inId = record.checkIn?.assistanceCheck_id as any;
    const outId = record.checkOut?.assistanceCheck_id as any;
    const partnerId = record.checkIn?.partner_id as any;
    await fetchCheckDetails(inId, outId, partnerId);
  };

  return (
    <>
      <tr className="text-center">
        <td>
          {toCamelCase(
            `${record.checkIn?.person_firstName} ${record.checkIn?.person_lastName} ${record.checkIn?.person_secondLastName}`
          )}
          {isNocturno && (
            <i
              className="fa-solid fa-moon ms-1 text-dark"
              title="Este colaborador tiene turno Nocturno registrado en RH"
            ></i>
          )}
        </td>
        <td> {record.checkIn?.position_name} </td>
        <td>{calculatedShift}</td>
        <td>
          {moment
            .utc(record.checkIn?.assistanceCheck_checkDate)
            .format("DD-MM-YYYY")}
        </td>
        <td> {record.checkIn?.assistanceCheck_checkTime} </td>
        <td> {record.checkOut?.assistanceCheck_checkTime ?? ""} </td>
        <td>
          {calcularTiempoTrabajado(
            record.checkIn?.assistanceCheck_checkTime!,
            record.checkOut?.assistanceCheck_checkTime
          )}
        </td>
        <td>{record.checkIn?.branch_name}</td>
        <td>
          <button className="btn btn-verde" onClick={() => handleClick()}>
            <i className="fa fa-eye"></i>
          </button>
        </td>
      </tr>

      <ModalContainer
        open={openCheckDetails}
        title="Historial de chequeos"
        closeFn={() => setOpenCheckDetails(false)}
        size="xl"
      >
        <ModalCheckDetails
          partnerId={record.checkIn?.partner_id}
          setShowModal={setOpenCheckDetails}
          checkDetails={checkDetails}
          profileImage={profileImage}
        />
      </ModalContainer>
    </>
  );
};

export default RowReporteChequeoCodigo;
